import { useMemo } from "react";
import { useAvatarImageModels } from "./useAvatarImageModels";
import { useAvatarPromptStyles } from "./useAvatarPromptStyles";
import { useValueFromStorage } from "../../hooks/useValueFromStorage";
import { LocalStorageKey } from "../../services/types";
export const useAvatarPersistedSettings = () => {
    const { modelsById, resolvedDefaultModelId } = useAvatarImageModels();
    const { promptStylesById, resolvedDefaultStyleId } = useAvatarPromptStyles();
    const [persistedModelId, setModelStyle] = useValueFromStorage({
        key: LocalStorageKey.AVATAR_GENERATOR_MODEL_KEY,
    });
    const [persistedStyleId, setPromptImageStyle] = useValueFromStorage({
        key: LocalStorageKey.AVATAR_GENERATOR_STYLE_KEY,
    });
    const modelStyle = useMemo(() => {
        if (!persistedModelId) {
            return resolvedDefaultModelId;
        }
        const found = modelsById[persistedModelId];
        if (!found || found.isDisabled) {
            return resolvedDefaultModelId;
        }
        return persistedModelId;
    }, [persistedModelId, modelsById, resolvedDefaultModelId]);
    const promptImageStyle = useMemo(() => {
        if (!persistedStyleId) {
            return resolvedDefaultStyleId;
        }
        return promptStylesById[persistedStyleId]
            ? persistedStyleId
            : resolvedDefaultStyleId;
    }, [persistedStyleId, promptStylesById, resolvedDefaultStyleId]);
    return { modelStyle, setModelStyle, promptImageStyle, setPromptImageStyle };
};
